import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import securityService from '../security/security.service';
import changePasswordService from './change-password.service'
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import DialogInput from '../software-dynamic-version-2/popup-dialog-input-v-2';
import './change-password.scss'

const ChangePassword = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

  const [inputProps, setInputProps] = useState({
    UserName:{
      name:{id:'UserID',value:'UserName'},
      caption: 'User Name',
      value: {id: securityService.getLoggedInUserId() ,value:securityService.getLoggedInUser() },
      dataSource: {type:'Route',route:'UserInfo'},
      enabled:securityService.getLoggedInUserId() == 1 ? true : false
    },
    OldPassword:{name: 'OldPassword',   value: '' },
    NewPassword:{name: 'NewPassword',   value: '' , enabled:false },
    ConfirmPassword:{name: 'ConfirmPassword',   value: '' , enabled:false},
    UpdatePassword:{name: 'UpdatePassword',   value: '' , enabled:false},
    });
// EXTRA CODE START
const dialogRef = useRef(null);
const showDialog = (header,title,actions =['OK']) => {
  return new Promise((resolve) => {
  // Destroy existing dialog if any
  if (dialogRef.current) {
    dialogRef.current.destroy();
  }
  const okButtons = actions.map((action) => ({
    buttonModel: {
      content: action,
      cssClass: 'e-flat',
      isPrimary: action === 'OK',
    },
    click: (e) => {
      hideDialog();
      resolve(action);
    },
  }));
  // Create a new dialog instance
  dialogRef.current = new DialogInput({
    content: ()=>(<>{title}</>),
    header:header,
    width:'340px',
    showButtons: true,
    buttons:okButtons
  });
  // Show the dialog programmatically
  dialogRef.current.show();

});

};
const hideDialog = () =>{
if (dialogRef.current) {
}
dialogRef.current.hide();
dialogRef.current.destroy();
dialogRef.current = null; // Clean up reference after destruction
}

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
  console.log(securityService.getLoggedInUser())
  if(name == 'OldPassword'){
  document.getElementById('OldPassword').focus()
  }
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  if(name == 'OldPassword'){
    console.log(value);
    changePasswordService.checkOldPassword(value,securityService.getLoggedInUserId()).then(async (res)=>{
      console.log(res)
      if(res.data.recordset.length  > 0 ){
        setInputProps((prevValues) => ({
          ...prevValues,
          ['NewPassword'] : {...prevValues['NewPassword'] ,enabled:true },
          ['ConfirmPassword'] : {...prevValues['ConfirmPassword'] ,enabled:true }
        }))
   
      }
    })

  }
  if( name == 'ConfirmPassword'){
  setTimeout(() => {
    
    if(inputProps.NewPassword.value == value ){
      setInputProps((prevValues) => ({
        ...prevValues,
        ['UpdatePassword'] : {...prevValues['UpdatePassword'] ,enabled:true },
      }))
    }
  }, 200);
  } 
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  if(name == 'OldPassword' && value != ''){
    console.log(value);
    changePasswordService.checkOldPassword(value,securityService.getLoggedInUserId()).then(async (res)=>{
      console.log(res)
      if(res.data.recordset.length  > 0 ){
        document.getElementById('NewPassword').focus()

      }else{
      await  showDialog('WARNING' ,'Old PASSWORD INCORRECT' )
      document.getElementById('OldPassword').focus()

      }
    })

  }
  else if(name == 'NewPassword'){
    if(value == ''){
      await  showDialog('WARNING' ,'Please Fill New PASSWORD' )
      document.getElementById('NewPassword').focus()
    }
  }
  else if(name == 'ConfirmPassword'){
    if(value == ''){
      await  showDialog('WARNING' ,'Please Fill Confirm PASSWORD' )
      document.getElementById('ConfirmPassword').focus()
      
    }else if(value != inputProps.NewPassword.value){
      await  showDialog('WARNING' ,'Confirm Password Incorrect!' )
      document.getElementById('ConfirmPassword').focus()

    }

  }
      console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };

  const handleOnClicked = (name)=>{
    console.log(name);
  changePasswordService.updatePassword(inputProps.NewPassword.value , securityService.getLoggedInUserId()).then(async (response)=>{
    await  showDialog('ALERT' ,' Password Changed Successfully!' )
    setInputProps((prevValues) => ({
      ...prevValues,
      ['NewPassword'] : {...prevValues['NewPassword'] ,value:'',enabled:false },
      ['ConfirmPassword'] : {...prevValues['ConfirmPassword'] ,value:'',enabled:false },
      ['OldPassword'] : {...prevValues['OldPassword'] ,value:'',enabled:true },
    }))
    document.getElementById('OldPassword').focus()

  })
  }
  let inputsList = [
    // { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    // {Input: DropdownComponent,Props: {...inputProps.UserName, setInputProps },ColumnSize:6},
    // { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    {Input: TextComponent,Props: {...inputProps.OldPassword,setInputProps , onCreated:handleInputCreated , onChange: handleInputChange ,onBlur:handleInputBlur},ColumnSize:6},
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    {Input: TextComponent,Props: {...inputProps.NewPassword,setInputProps, onBlur:handleInputBlur, onChange: handleInputChange },ColumnSize:6},
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},

    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    {Input: TextComponent,Props: {...inputProps.ConfirmPassword,setInputProps , onBlur:handleInputBlur, onChange: handleInputChange },ColumnSize:6},
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},

    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    {Input: ButtonComponent,Props: {...inputProps.UpdatePassword,setInputProps, onClick:handleOnClicked },ColumnSize:6},
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3}
    ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}  className='content-wrapper' style={{padding:'15px'}}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`CHANGE PASSWORD `} Inputs={inputsList}/>
      {/* <StructuredGenerate   mainProps={props} title={`CHANGE PASSWORD ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/> */}
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default ChangePassword;
